import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=1cd4772b&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=ts"
export * from "./CompanySettings.vue?vue&type=script&lang=ts"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=1cd4772b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4772b",
  null
  
)

export default component.exports